import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import Iconify from 'src/components/Iconify';
import { MKT_CTWA_DESIGN as d } from 'src/pages/dashboard/Marketing/MarketingCtwa.design';

const CANAIS_PATH = '/dashboard/configuracoes/canais';

export default function CtwaWabaHero() {
    const { t } = useTranslation('marketing');
    const navigate = useNavigate();

    return (
        <div className={d.wabaHero.wrap}>
            <div className={d.wabaHero.card}>
                <div className={d.wabaHero.iconBox}>
                    <Iconify icon="logos:whatsapp-icon" width={32} />
                </div>

                <h2 className={d.wabaHero.title}>{t('ctwaPage.noWabaChannelTitle')}</h2>
                <p className={d.wabaHero.subtitle}>{t('ctwaPage.noWabaChannelDescription')}</p>

                <button
                    type="button"
                    className={d.wabaHero.cta}
                    onClick={() => navigate(CANAIS_PATH)}
                >
                    {t('ctwaPage.noWabaChannelCta')}
                </button>
            </div>
        </div>
    );
}
